module.exports = __webpack_public_path__ + "img/426bb55.png";